export default __webpack_public_path__ + "static/Transform-b47b76fe9abe7463818ec6768dcfba58.webp";